import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "wo-props-container"
};
const _hoisted_2 = {
  key: 0,
  class: "wo-props-list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "prop-content"
};
const _hoisted_5 = {
  class: "prop-name"
};
const _hoisted_6 = {
  key: 1,
  class: "empty-data-tips"
};
const _hoisted_7 = {
  key: 2,
  class: "pagination-container"
};
import { ref, computed, onMounted } from 'vue';
import { ElIcon, ElMessage } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import { request } from '@/manager/net_manager';
import { inApostleType } from '@/tools/utils';
import store from '@/store';
import MaskerLayer from '@/components/Basic/MaskerLayer.vue';
import PocketPropsHeader from '@/components/Props/PocketPropsHeader.vue';
import RolePropsEditCard from '@/components/Props/RolePropsEditCard.vue'; // refs

export default {
  __name: 'WORoleProps',

  setup(__props) {
    const dataArray = ref([]);
    const roleProp = ref(null);
    const pagerCount = ref(5);
    const size = ref(30);
    const total = ref(0);
    const page = ref(0);
    const cacheFilterInfo = ref({}); // computed

    const worldOutlook = computed(() => {
      return store.state.world_outlook ? store.state.world_outlook : null;
    });
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4); // functions

    const getData = (filterInfo = null) => {
      if (!worldOutlook.value) return;
      let parameters = {
        'world_outlook_id': worldOutlook.value.id,
        'page': page.value,
        'size': size.value
      };

      if (filterInfo) {
        cacheFilterInfo.value = filterInfo;
        Object.entries(filterInfo).forEach(item => {
          parameters[item[0]] = item[1];
        });
      } else if (Object.keys(cacheFilterInfo.value).length !== 0) {
        Object.entries(cacheFilterInfo.value).forEach(item => {
          parameters[item[0]] = item[1];
        });
      } // console.log(JSON.stringify(parameters))


      request('props/role_props/list/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        dataArray.value = response.data.props;
        total.value = response.data.numbers;
      });
    };

    const updateFilter = filterInfo => {
      page.value = 0;
      getData(filterInfo);
    };

    const handlePageChange = index => {
      page.value = index - 1;
      getData();
    };

    const createProp = () => {
      roleProp.value = {};
    };

    const selectedProp = item => {
      roleProp.value = item;
    };

    const closeProp = () => {
      roleProp.value = null;
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      const _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        style: {
          "justify-content": "flex-start"
        }
      }, {
        default: _withCtx(() => [_unref(inApostleType)(userType.value) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "create-prop-card",
          onClick: createProp
        }, [_createVNode(_unref(ElIcon), {
          size: "14"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Plus))]),
          _: 1
        }), _cache[0] || (_cache[0] = _createElementVNode("text", null, "创建角色道具", -1))])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(PocketPropsHeader, {
        "has-sort": false,
        onUpdateFilter: updateFilter
      }), dataArray.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key) => {
        return _openBlock(), _createElementBlock("div", {
          key: key,
          class: "prop-card",
          onClick: $event => selectedProp(item)
        }, [_createElementVNode("text", _hoisted_4, [_createTextVNode(" No." + _toDisplayString(item.id) + " ", 1), _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1)])], 8, _hoisted_3);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [_createElementVNode("text", {
        style: {
          "display": "flex"
        }
      }, "未发现角色道具数据", -1)]))])), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true), roleProp.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 3,
        onClose: closeProp
      }, {
        default: _withCtx(() => [_createVNode(RolePropsEditCard, {
          "role-prop-id": roleProp.value.id,
          onReload: getData,
          onClose: closeProp
        }, null, 8, ["role-prop-id"])]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }

};